import { CheckboxField, H5, SlateViewer } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import styled from "styled-components";
import { ConsentIndexResource } from "../types/consent";

interface Props {
	consent: ConsentIndexResource;
	name: string;
}

export const ConsentWrapper = styled.div`
	display: grid;
	grid-template-rows: max-content 1fr;
	gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledCheckbox = styled(CheckboxField)`
	align-items: start;

	label {
		color: ${({ theme }) => theme.colors.forms.label};
		font-size: 1rem;
	}
`;

export const Error = styled.div`
	${({ theme }) => theme.forms.error};
	position: relative;
	padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const CheckboxConsent: FC<Props> = ({ consent, name }) => {
	const [, meta] = useField(name);

	return (
		<ConsentWrapper>
			{consent.headline && <H5>{consent.headline}</H5>}
			<StyledCheckbox label={<SlateViewer content={consent.consent} />} name={name} />
			{meta.touched && meta.error && <Error id={`${name}_error`}>{meta.error}</Error>}
		</ConsentWrapper>
	);
};
